import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, AvatarSize } from '../../../DesignSystem/VendorProfile/Avatar';

interface AccountSettingsHeaderProps {
  businessName: string;
  accountNumber: string;
  customerId: string;
}

export const AccountSettingsHeader = ({ businessName, accountNumber, customerId }: AccountSettingsHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-row items-center gap-[12px] border-bw03 border-[1px] rounded-xl shadow-widgetCard px-[32px] py-[12px] bg-bw00'>
      <Avatar name={businessName} id={customerId} size={AvatarSize.XLRAGE} />
      <div className='flex flex-col'>
        <p className='text-bw08 text-[24px] font-metricRMedium' id='businessName'>
          {businessName}
        </p>
        <p id='accountNumber' className='text-bw07 text-[16px] font-metricR'>{`${t('ACCOUNT_SETTINGS.ACCOUNT_NUMBER')} - ${accountNumber}`}</p>
      </div>
    </div>
  );
};
